import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys } from '../react-query.config';

export interface SquareReservation {
  reservationId: string;
  userId: string;
  username: string | null;
  ssoUserId: string | null;
  /** 'reserved' (no picks yet) or 'entered' (converted when picks were submitted) */
  status: string;
  reservedAt: string | null;
  picksSubmittedAt: string | null;
}

export interface GetReservationsResponse {
  questionId: string;
  pickemId: string;
  reservations: SquareReservation[];
  totalReservations: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface GetReservationsParams {
  page?: number;
  limit?: number;
  search?: string;
}

export async function getReservations(
  squareId: string,
  params?: GetReservationsParams
): Promise<GetReservationsResponse> {
  const queryParams = new URLSearchParams();
  if (params?.page !== undefined) queryParams.set('page', String(params.page));
  if (params?.limit !== undefined) queryParams.set('limit', String(params.limit));
  if (params?.search) queryParams.set('search', params.search);

  const qs = queryParams.toString();
  const url = `/api/admin/squares/${squareId}/reservations${qs ? `?${qs}` : ''}`;
  const response = await (apiClient as any).get(url);
  return response as GetReservationsResponse;
}

export function useGetReservationsQuery(squareId: string | null, params?: GetReservationsParams) {
  return useQuery<GetReservationsResponse>({
    queryKey: queryKeys.squares.reservations(squareId, params),
    queryFn: () => getReservations(squareId!, params),
    enabled: !!squareId,
  });
}
